export default __webpack_public_path__ + "static/media/gpa-lng-forum-button2-small2.ad291384.jpg";